import { render } from "./TermsConditions.vue?vue&type=template&id=68060f1f"
const script = {}
script.render = render

export default script